import { useState } from "react";
import type { FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "明星八卦", to: "/category/star" },
  { label: "社会热点", to: "/category/society" },
  { label: "行业秘闻", to: "/category/industry" },
  { label: "职场爆料", to: "/category/workplace" },
  { label: "全网热榜", to: "/rank" },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    navigate(trimmed ? `/search?q=${encodeURIComponent(trimmed)}` : "/search");
    setMobileOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg font-bold">
              <i className="ri-fire-fill" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <strong className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                吃瓜看料
              </strong>
              <span className="text-[10px] tracking-[0.2em] text-foreground-500">
                GOSSIP BASE
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors ${
                  isActive(link.to)
                    ? "text-primary-600 font-semibold"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden md:flex items-center">
              <div className="flex items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-3 py-1.5 focus-within:border-primary-400">
                <i className="ri-search-line text-foreground-500 text-sm" aria-hidden="true"></i>
                <input
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  type="search"
                  placeholder="搜瓜名、明星、公司…"
                  className="w-36 xl:w-44 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
                />
              </div>
            </form>
            <Link
              to="/rank"
              className="hidden md:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-3.5 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-flashlight-fill" aria-hidden="true"></i>
              看热榜
            </Link>
            <button
              type="button"
              onClick={() => setMobileOpen((open) => !open)}
              className="lg:hidden flex h-9 w-9 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 py-4">
          <form onSubmit={handleSearch} className="mb-3 flex items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-3 py-2">
            <i className="ri-search-line text-foreground-500 text-sm" aria-hidden="true"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              type="search"
              placeholder="搜瓜名、明星、公司…"
              className="w-full bg-transparent text-sm outline-none"
            />
          </form>
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`rounded-md px-3 py-2 text-sm text-center whitespace-nowrap ${
                  isActive(link.to)
                    ? "bg-primary-500 text-background-50 font-semibold"
                    : "bg-background-100 text-foreground-800"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}